<template>
  <panelify
    extName="camAssist"
    appName="AEFT"
    src="https://camera-manager-panel.web.app/#/"
    width="450px"
    height="300px"
    :gradient="0"
  />
</template>

<script>
import { panelify } from "@inventsable/panelify";

export default {
  components: {
    panelify
  }
};
</script>